import { render, staticRenderFns } from "./grid-widget.vue?vue&type=template&id=3f115d3f&scoped=true&"
import script from "./grid-widget.vue?vue&type=script&lang=js&"
export * from "./grid-widget.vue?vue&type=script&lang=js&"
import style0 from "./grid-widget.vue?vue&type=style&index=0&id=3f115d3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f115d3f",
  null
  
)

export default component.exports